module.exports = __webpack_public_path__ + "static/media/27.6a9719f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/27.svg
// module id = 420
// module chunks = 14